import { defineComponent as _defineComponent } from 'vue'

import type { MaterialV1 } from '@ilteducation/content-registry-types';
import MaterialsForm from './Form.vue';

type Props = {
  id: string;
  title: string;
  item: MaterialV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {



return { __sfc: true,MaterialsForm }
}

})